import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const RequestResetPasswordDialogSchema = z.object({
  email: z.string().email({
    message: "メールアドレスを入力してください",
  }),
});

export type RequestResetPasswordDialogSchemaType = z.infer<
  typeof RequestResetPasswordDialogSchema
>;

export const useRequestResetPasswordDialog = (
  onRequestRecovery: (email: string) => Promise<void>,
) => {
  const form = useForm<RequestResetPasswordDialogSchemaType>({
    defaultValues: {
      email: "",
    },
    resolver: zodResolver(RequestResetPasswordDialogSchema),
  });

  const onSubmit = async (values: RequestResetPasswordDialogSchemaType) => {
    try {
      await onRequestRecovery(values.email);
    } catch (_) {
      form.setError("email", {
        message: "エラーが発生しました。再度メールアドレスを入力してください",
      });
    }
  };

  return {
    form,
    onSubmit,
  };
};
